import React from 'react'
import PropTypes from 'prop-types'
import UserTableItem from "./UserTableItem"

UserTableList.propTypes = {
    users: PropTypes.array,
    error: PropTypes.string
}

function UserTableList(props) {
    const {users, error} = props

    return (
        <tbody className='UserTableList'>
        {
            !!users && users.length > 0 && users.map((item, index) => (
                <UserTableItem {...props} key={index} user={item}/>
            ))
        }
        {
            !!error && error.length > 0 && <tr>
                <td colSpan={4} className="text-danger mt-3">{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default UserTableList
